import Column from '@components/Column';
import { ShopInMapRow } from '@models/shop';

import ShopMap from './ShopMap';
import ShopList from '../ShopList';
import useShopsInMap from './hooks/useShopsInMap';
import styles from './styles.module.scss';

interface Props {
    isOrder?: boolean;
    originalItemId?: string;
    shops?: ShopInMapRow[];
    fetchNext?: ()=> void;
}

function MapAndList({
    isOrder, originalItemId, shops, fetchNext,
}:Props) {
    const { markers } = useShopsInMap({
        originalItemId, isOrder,
    });
    return (
        <Column fullWidth fullHeight>
            <div className={styles.map}>
                <ShopMap markers={markers}
                    shops={shops}
                    isOrder={!!isOrder} />
            </div>
            <div className={styles.list}>
                <ShopList isOrder={!!isOrder}
                    originalItemId={originalItemId}
                    shops={shops}
                    isBlank={shops?.length === 0}
                    fetchNext={fetchNext}
                    fit />
            </div>
        </Column>
    );
}

export default MapAndList;
